import { jsx as g } from "react/jsx-runtime";
import { offerDefaultErrors as h } from "../../../pages/checkout/constants/default-errors.mjs";
import { BadRequest as D } from "@systemeio/util";
import E from "../../../ui-kit/theme-button.mjs";
import { useStripe as P, useElements as T } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { useStore as j } from "../../../store/index.mjs";
import { stripeBuyOffer as q } from "../api/stripe-api.mjs";
import { twJoin as x } from "tailwind-merge";
import { IntentTypeEnum as O } from "../enum/intent-type-enum.mjs";
function H({
  isFetching: c,
  buttonTitle: l,
  buttonDisabled: u,
  setErrors: n,
  setIsFetching: i,
  preSubmit: p,
  handleBadRequest: d,
  hasErrors: y
}) {
  const { locale: b } = j(), r = P(), o = T(), w = async (B) => {
    if (B.preventDefault(), !(!r || !o))
      try {
        i(!0), n(h);
        const { error: e } = await o.submit();
        if (e) return;
        const t = p();
        if (!t) return;
        const { redirect: m, intentSecret: a, intentType: S } = await q(t, b);
        if (!a) return window.location.href = m;
        const _ = S === O.setup ? r.confirmSetup : r.confirmPayment, { error: s } = await _({
          elements: o,
          clientSecret: a,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: [t.customer.fields.first_name, t.customer.fields.last_name].filter(Boolean).join(" "),
                email: t.customer.fields.email
              }
            },
            return_url: m
          }
        });
        s && n((f) => ({ ...f, common: [...f.common, s.message] }));
      } catch (e) {
        if (e instanceof D)
          d(e);
        else
          throw e;
      } finally {
        i(!1);
      }
  };
  return /* @__PURE__ */ g(
    E,
    {
      disabled: u,
      className: x("main-transition-colors", y && "bg-danger focus:bg-danger"),
      onClick: w,
      isFetching: c,
      type: "submit",
      children: l
    }
  );
}
export {
  H as RedirectBasedPaymentButton
};
